import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { AccountCrComponent } from '../mdm/account/change-requests/account-cr';
import { AssessmentModule } from '../assessment/assessment.module';

import { AccountPageComponent } from './account-page/account-page';
import { AccountListComponent } from './account-list/account-list';
import { AccountDetailsComponent } from './account-details/account-details';
import { ConfiguredAccountInfoComponent } from './configured-account-info/configured-account-info';
import { AccountListItemComponent } from './account-list-item/account-list-item';
import { AccountListRoComponent } from './account-list-ro/account-list-ro';
import { AccountTimelineComponent } from './account-timeline/account-timeline';
import { AccountProfileComponent } from './account-profile/account-profile';
import { AccountFeedComponent } from './account-feed/account-feed';
import { AccountTimelinePageComponent } from './account-timeline-page/account-timeline-page.component';
import { OfftakeCheckProductComponent } from './offtake-check-collection/offtake-check-product/offtake-check-product.component';
import { OfftakeCheckComponent } from './offtake-check-collection/offtake-check/offtake-check.component';
import { TrendingAccountsComponent } from '../trending-accounts/trending-accounts';
import { SpotlightAiSummaryComponent } from '../contact/contact-spotlight/spotlight-ai-summary/spotlight-ai-summary.component';
import { NovaRecordContextDirective } from '../nova-voice/nova-record-context.directive';

const ACCOUNT_DECLARATIONS = [
  AccountPageComponent,
  AccountListComponent,
  AccountDetailsComponent,
  ConfiguredAccountInfoComponent,
  AccountListItemComponent,
  AccountListRoComponent,
  AccountTimelineComponent,
  AccountProfileComponent,
  AccountFeedComponent,
  AccountTimelinePageComponent,
  OfftakeCheckProductComponent,
  OfftakeCheckComponent,
  TrendingAccountsComponent,
];

@NgModule({
  imports: [SharedModule, ScrollingModule, AccountCrComponent, AssessmentModule, SpotlightAiSummaryComponent, NovaRecordContextDirective],
  declarations: ACCOUNT_DECLARATIONS,
  exports: ACCOUNT_DECLARATIONS,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AccountModule {}
